import _ from 'lodash';
import * as types from './types';
import { ControlInfoEnum as Fields } from 'Common/FieldEnum';
import { VerificationTypes } from '../../components/VerificationTypes';
import { defaultDateFormat } from 'Common/GeneralHelper';

const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  fetchError: null,
  data: {
    [Fields.VerificationConfigurationType]: VerificationTypes.standard,
    [Fields.CountApplicationAsOf]: '',
    [Fields.CountStudentAsOf]: '',
    [Fields.RandomApplicationPercentage]: 0,
    [Fields.ErrorProneApplicationPercentage]: 0,
    [Fields.ErrorProneLimit]: 100,
    [Fields.Alt2ApplicationPercentage]: 0,
    [Fields.Alt2CaseNumberPercentage]: 0,
    [Fields.Alt2Limit]: 100,
    verificationStatus: {},
  },
  submitting: false,
  submitted: false,
  submitError: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.VERIFICATION_CONFIG_SET_TYPE:
      return {
        ...state,
      };

    case types.VERIFICATION_CONFIG_FETCHING:
      return {
        ...state,
        fetching: payload,
        fetched: payload ? false : state.fetched,
      };

    case types.VERIFICATION_CONFIG_FETCH:
      const { controlInfo } = payload;

      // controlInfo.verificationStatus.Phase = 1;
      // controlInfo.verificationStatus.IsComplete = true;

      return {
        ...state,
        data: {
          ...state.data,
          [Fields.VerificationConfigurationType]:
            controlInfo[Fields.VerificationConfigurationType],
          [Fields.CountApplicationAsOf]: defaultDateFormat(
            controlInfo[Fields.CountApplicationAsOf]
          ),
          [Fields.CountStudentAsOf]: defaultDateFormat(
            controlInfo[Fields.CountStudentAsOf]
          ),
          [Fields.RandomApplicationPercentage]:
            controlInfo[Fields.RandomApplicationPercentage],
          [Fields.ErrorProneApplicationPercentage]:
            controlInfo[Fields.ErrorProneApplicationPercentage],
          [Fields.ErrorProneLimit]: controlInfo[Fields.ErrorProneLimit],
          [Fields.Alt2ApplicationPercentage]:
            controlInfo[Fields.Alt2ApplicationPercentage],
          [Fields.Alt2CaseNumberPercentage]:
            controlInfo[Fields.Alt2CaseNumberPercentage],
          [Fields.Alt2Limit]: controlInfo[Fields.Alt2Limit],
          verificationStatus: controlInfo.verificationStatus,
        },
      };

    case types.VERIFICATION_CONFIG_FETCH_ERROR:
      const hardCodedError = {
        Title: 'Error',
        Message:
          'An error occurred while fetching the Verification Configuration. Please try again',
      };

      if (_.has(payload, 'response.data')) {
        if (payload.response.data.Errors === undefined) {
          return {
            ...state,
            fetchError: hardCodedError,
          };
        }

        const fetchError = payload.response.data.Errors[0];
        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: hardCodedError,
      };

    case types.VERIFICATION_CONFIG_SUBMITTING:
      return {
        ...state,
        submitting: payload,
        submitted: payload ? false : state.submitted,
      };

    case types.VERIFICATION_CONFIG_SUBMIT:
      return {
        ...state,
        submitted: true,
      };

    case types.VERIFICATION_CONFIG_SUBMIT_ERROR:
      const hardCodedSubmitError = {
        Title: 'Error',
        Message:
          'An error occurred while submitting the Verification Configuration. Please try again',
      };
      if (_.has(payload, 'response.data')) {
        if (payload.response.data.Errors === undefined) {
          return {
            ...state,
            fetchError: hardCodedSubmitError,
          };
        }

        const fetchError = payload.response.data.Errors[0];
        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: hardCodedSubmitError,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/verificationconfiguration/state/configuration/reducer.js